import {MapContainer, TileLayer, Circle, Popup} from 'react-leaflet'
import {LatLngExpression} from 'leaflet'
import 'leaflet/dist/leaflet.css'

interface IMarker {
  position: [number, number]
  name: string
  quantidade: number
}

interface HeatCircleMapProps {
  markers: IMarker[]
}

const HeatCircleMap = ({markers}: HeatCircleMapProps) => {
  const center: LatLngExpression = markers.length ? markers[0].position : [-14.235, -51.9253] // fallback: centro do Brasil

  return (
    <MapContainer center={center} zoom={10} style={{height: '100%', width: '100%'}}>
      <TileLayer attribution='&copy; OpenStreetMap' url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />

      {markers.map((marker, idx) => (
        <Circle
          key={idx}
          center={marker.position}
          radius={100}
          pathOptions={{
            color: 'red',
            fillColor: 'red',
            fillOpacity: 0.4,
          }}
        >
        </Circle>
      ))}
    </MapContainer>
  )
}

export default HeatCircleMap
